module.exports = __webpack_public_path__ + "static/media/7.question.a10b55a8.mp4";